/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable default-case */
// import React from "react";
import Iframe from 'react-iframe';
// import RenderPDFViewer from '../../components/iframe-viewer/pdfViewer';
import ReactPlayer from 'react-player';
import { Image, Empty } from 'antd';
// import SimpleBarReact from "simplebar-react";
// import { PDFReader } from 'reactjs-pdf-reader';
// import { RenderPDFReader } from '../../components/pdfreader/RenderPDFReader';
import ResponsivePdfViewer from './ResponsivePdfViewer';

// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
// import "@cyntler/react-doc-viewer/dist/index.css";

// const DocumentViewer = ({ document, documentlist, document_link = null, pdfheight, pdfshowdownload = false, pdfshowprint = false, videoheight, viewerheight, ismodal = false }) => {
const DocumentViewer = ({ document, documentname = null, documentlist, document_link = null, pdfshowdownload = false, pdfshowprint = false, dvheight, emptydescription = 'No documents available.', ismodal = false }) => {

   const subdomain = localStorage.getItem("lms-subdomain");

   const safeCalcHeight = (baseHeight, offsetPx = 0) => {
      if (!baseHeight || offsetPx === 0) return baseHeight;

      const trimmed = String(baseHeight).trim();
      // Avoid invalid CSS like `calc(calc(100vh - 200px) - 10px)`
      const inner = trimmed.startsWith('calc(') && trimmed.endsWith(')')
         ? trimmed.slice(5, -1)
         : trimmed;

      return `calc(${inner} - ${offsetPx}px)`;
   };

   const normalizeUrl = (url) => {
      if (!url) return url;
      // Keep it simple: encode common troublemakers while preserving querystrings.
      return String(url).replace(/ /g, '%20').replace(/#/g, '%23');
   };

   const resolveDocumentUrl = (doc) => {
      if (!doc) return null;

      const raw = String(doc).trim();
      // If API already returns a full URL (or data/blob URL), use it as-is
      if (/^(https?:)?\/\//i.test(raw) || /^(data|blob):/i.test(raw)) {
         return normalizeUrl(raw);
      }

      const base = `${process.env.REACT_APP_API_S3_URL}/${subdomain}`;
      const path = raw.startsWith('/') ? raw.slice(1) : raw;
      return normalizeUrl(`${base}/${path}`);
   };

   const getExtension = (value) => {
      if (!value) return null;

      const clean = String(value).split('?')[0].split('#')[0];
      const match = /(?:\.([^.]+))?$/.exec(clean.toLowerCase());
      return match && match[1] ? match[1] : null;
   };

   const renderPreviewer = () => {
      if (document !== null && document !== '') {
         const ext = getExtension(documentname || document);
         const url = resolveDocumentUrl(document);

         if (!url) return null;

         switch (ext) {
            case "pdf":
               return <>
                  <ResponsivePdfViewer
                     fileUrl={url}
                     height={dvheight}
                     pageLayout={{
                        transformSize: ({ size }) => ({
                           height: size.height + 30,
                           width: size.width + 30,
                        }),
                     }}
                     secureMode={true}
                     // watermarkText={`CAMPUSCLOUDPH PROPERTY`}
                     watermarkText={``}
                  />
                  {/* <RenderPDFReader url={url} height={dvheight} /> */}
                  {/* <RenderPDFViewer url={url} height={dvheight} showdownload={pdfshowdownload} showprint={pdfshowprint} showpagecontrols={true} showfullscreen={true} /> */}
               </>

            case "doc":
            case "docx":
            case "xls":
            case "xlsx":
            case "ppt":
            case "pptx":
            case "ppsx":
               {
                  // const docs = [{ title: 'Sample', uri: url }];
                  return <>
                  {/* <OnlyOfficeViewer
                     docUrl={url}
                     title="Document"
                     serverUrl="http://localhost:8080"
                     height='99%'
                     width='100%'
                  /> */}
                     {/* <DocViewer
                        documents={docs}
                        initialActiveDocument={docs[0]}
                        pluginRenderers={DocViewerRenderers}
                        prefetchMethod="GET"
                        style={{ height: safeCalcHeight(dvheight, 10) }}
                        config={{
                           header: {
                              disableHeader: true,
                              disableFileName: true,
                              retainURLParams: false,
                           },
                           csvDelimiter: ",", // "," as default,
                           pdfZoom: {
                              defaultZoom: 1.1, // 1 as default,
                              zoomJump: 0.2, // 0.1 as default,
                           },
                           pdfVerticalScrollByDefault: true, // false as default
                        }}
                     /> */}
                  <div
                     className={ismodal ? 'modal-document-viewer' : 'document-viewer'}
                     style={{ height: safeCalcHeight(dvheight, 11) }}>
                     <Iframe
                        id="msdoc-iframe"
                        title="msdoc-iframe"
                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
                        frameBorder="0"
                        height='100%'
                        width='100%'
                        loading='eager'
                     />
                  </div>
                  </>
               }

            case "png": case "jpg": case "jpeg":
               return <>
                  <div
                     className={ismodal ? 'modal-document-viewer' : 'document-viewer'}
                     // style={ismodal ? { height: dvheight } : { height: "calc(" + dvheight + " - 8px)" }}
                     style={{ height: safeCalcHeight(dvheight, 8) }}
                  >
                     <Image
                        src={url}
                        style={{ maxHeight: safeCalcHeight(dvheight, 8) }}
                     />
                  </div>
               </>

            case "mp4": case "avi": case "mp3": case "wav":
               return <>
                  <ReactPlayer
                     controls={true}
                     width='100%'
                     height={safeCalcHeight(dvheight, 6)}
                     url={url}
                  />
               </>

            default:
               return <>
                  <div
                     className={ismodal ? 'modal-document-viewer' : 'document-viewer'}
                     style={{ height: safeCalcHeight(dvheight, 10) }}
                  >
                     <Empty
                        description={
                           <span>
                              Preview not available for this file type.
                              {' '}
                              <a href={url} target="_blank" rel="noreferrer">Open in new tab</a>
                           </span>
                        }
                        image="../images/brainee_mascot.png"
                     />
                  </div>
               </>
         }
      }
      else if (document_link !== null && document_link !== '') {
         return <>
            <div
               className={ismodal ? 'modal-document-viewer' : 'document-viewer'}
               // style={ismodal ? { height: dvheight } : { height: "calc(" + dvheight + " - 10px)" }}
               style={{ height: safeCalcHeight(dvheight, 10) }}
            >
               <a href={`${document_link}`} title="Click here to view the document" target={"_blank"}>Click here to view the document</a>
            </div>
         </>
      }
      else if (documentlist !== null && documentlist !== '') {
         return <>
            <div
               className={ismodal ? 'modal-document-viewer' : 'document-viewer'}
               // style={ismodal ? { height: dvheight } : { height: "calc(" + dvheight + " - 10px)" }}
               style={{ height: safeCalcHeight(dvheight, 10) }}
            >
               <Empty description='Click an item in the document list to view.'
                  image="../images/brainee_mascot.png"
               />
            </div>
         </>
      }
      else {
         return <>
            <div
               className={ismodal ? 'modal-document-viewer' : 'document-viewer'}
               // style={ismodal ? { height: dvheight } : { height: "calc(" + dvheight + " - 10px)" }}
               style={{ height: safeCalcHeight(dvheight, 10) }}
            >
               <Empty
                  description={emptydescription}
                  image="../images/brainee_mascot.png"
               />
            </div>
         </>
      }
      // return <>
      //    {
      //       documentlist !== null && documentlist !== ''
      //          ?
      //          <div className={ismodal ? 'modal-document-viewer' : 'document-viewer'}>
      //             <Empty description='Click an item in the document list to view.' />
      //          </div>
      //          :
      //          <div className={ismodal ? 'modal-document-viewer' : 'document-viewer'}>
      //             <Empty description='No uploaded documents found.' />
      //          </div>
      //    }
      // </>
   }

   return (
      <>
         {renderPreviewer()}
      </>
   );
}

export default DocumentViewer;
